export const environment = {
    production: false,
    appVersion: '2.5.3',
    urls: {
        api: 'https://api.n2g-iona.net/v2/',
        auth: 'https://iona-test-live.wla-backend.de/auth',
        faq: 'https://iona-dev.wla-backend.de/faq/iona/?showNav=true',
        rewriteUrl: '',
        userGroup: 'https://ews.n2g-iona.net/api',
    },
    isStaging: false
};


